import { Component, useEffect, useState } from "react";
import { RefreshCw, WifiOff } from "lucide-react";
import { Button } from "./ui/button";

export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("CrickHere screen error", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="flex min-h-[100dvh] items-center justify-center bg-background px-5 text-foreground">
        <section className="w-full max-w-sm text-center" role="alert">
          <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-destructive/10 text-destructive">
            <RefreshCw className="h-6 w-6" />
          </div>
          <h1 className="font-heading text-xl font-semibold">This screen could not load</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Your data is safe. Reload the app to continue.
          </p>
          <Button className="mt-6 w-full" onClick={this.handleReload}>
            <RefreshCw className="h-4 w-4" />
            Reload app
          </Button>
        </section>
      </main>
    );
  }
}

export const NetworkStatus = () => {
  const [online, setOnline] = useState(() =>
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    const handleNativeNetwork = (event) => setOnline(event.detail?.connected !== false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("crickhere:network", handleNativeNetwork);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("crickhere:network", handleNativeNetwork);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="pointer-events-none fixed inset-x-3 top-[calc(0.5rem+var(--app-safe-top))] z-[110] flex justify-center"
      role="status"
      aria-live="polite"
    >
      <div className="flex min-h-10 items-center gap-2 rounded-md border border-amber-500/30 bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-900 shadow-lg dark:bg-amber-950 dark:text-amber-100">
        <WifiOff className="h-4 w-4 shrink-0" />
        You are offline. Some actions may be unavailable.
      </div>
    </div>
  );
};
